import { tokenStore } from '@lib/tokenStore';
import { refreshAccessToken } from '@lib/baseQuery';

/**
 * Bearer token for direct (non-RTK) fetch/XHR calls: refreshes if the in-memory
 * token expired, returns null if none can be obtained so callers don't send a
 * stale bearer. RTK requests get the same refresh via portalBaseQuery.
 */
export async function getValidToken(): Promise<string | null> {
  if (tokenStore.isAccessTokenExpired()) {
    if (!tokenStore.getRefreshToken()) return null;
    try {
      await refreshAccessToken();
    } catch {
      return null;
    }
    if (tokenStore.isAccessTokenExpired()) return null;
  }
  return tokenStore.getAccessToken();
}
